import React from 'react';
import BomMaterialRow from './BomMaterialRow';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormSearchButton from '../../../../library/form/components/FormSearchButton'
import { UiView, UiViewHeading, UiViewContent, UiAction } from "../../../../library/layout/Index";

const BomMaterialGroup = (props) => {
    const { formObject, viewData, groupData, groupKey } = props;

    return (
        <UiView>
            <UiViewHeading>
                <UiAction>
                    <div className='uiFlexBoxRight'>
                        <span><SarasTrans value={groupData.valF} /></span>
                        <FormSearchButton formObject={formObject} rowKey="" headerKey='lineItemLink' filterKey={groupKey}
                            action={{ actionId: "refresh",  actionParam: { } }}
                            className='uiActionButton' inputClass='uiSpacerH10'
                        />
                    </div>
                </UiAction>
            </UiViewHeading>
            <UiViewContent>
                <ul className="uiListTable">
                    <li className="uiSearchHeading">
                        <ul>
                            <li className="uiColumnCenter uiColumn50"><SarasTrans value="Sr No." /></li>
                            <li className="uiColumnCenter uiColumn100"><SarasTrans value="Item ID" /></li>
                            <li className="uiColumnCenter uiColumn250"><SarasTrans value="Item Name" /></li>
                            <li className="uiColumnCenter uiColumn100"><SarasTrans value="Nick Name" /></li>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Unit" /></li>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Quantity" /></li>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Unit Cost" /></li>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Est. Val." /></li>
                            <li className="uiColumnCenter uiColumn200"><SarasTrans value="Details" /></li>
                            <li className="uiColumnCenter uiColumn50"><SarasTrans value="SIH" /> </li>
                            <li className="uiColumnCenter uiColumn60"><SarasTrans value="Action" /> </li>
                        </ul>
                    </li>
                    {
                        Object.values(viewData ? viewData : {}).map((row, index) => (
                            <li><BomMaterialRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} index={index + 1}/></li>
                        ))
                    }
                </ul>
            </UiViewContent>
        </UiView>
    )
}

export default BomMaterialGroup